import { combineContextProviders } from './root/utils';
import { ReactQueryProvider } from './root/components/ReactQueryProvider';

const providers = [ReactQueryProvider];

const CoreProvider = combineContextProviders(...providers);

export default CoreProvider;
